import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Organisation } from "../../models/organisation.model";
import { User } from "../../models/user.model";
import { UserDataProvider } from "../../data-provider/user.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { OrganisationUserDataProvider } from "../../data-provider/organisation-user.dp";

let ViewOrganisationUserComponent = {
    selector: "vcViewOrganisationUser",
    templateUrl:
        "/angular/components/organisation-user/view-organisation-user.component.html",
    bindings: {
        selectedUser: "=?",
        selectedUserId: "=?",
        editable: "=?",
        onUserUpdated: "&?",
        onUserDeleted: "&?",
    },
    controller: class ViewOrganisationUserController {
        // * bindings for typescript compiler *
        public selectedUser?: any;
        public selectedUserId?: any;
        public editable?: any;
        public onUserUpdated?: any;
        public onUserDeleted?: any;
        // ************************************

        private $scope: any;
        private userDataProvider: UserDataProvider;
        private campaignDataProvider: CampaignDataProvider;
        private organisationUserDataProvider: OrganisationUserDataProvider;
        private toast: ToastUtils;
        private dialog: DialogUtils;
        private modelsUtils: any;

        public user: User;
        public signedInUser: User;
        public activeOrganisation: Organisation;

        constructor(
            $scope: any,
            ModelsUtils: any,
            UserDataProvider: UserDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            OrganisationUserDataProvider: OrganisationUserDataProvider,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils
        ) {
            this.$scope = $scope;
            this.modelsUtils = ModelsUtils;
            this.userDataProvider = UserDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.organisationUserDataProvider = OrganisationUserDataProvider;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;

            this.signedInUser = this.userDataProvider.getActiveUser();

            this.campaignDataProvider
                .getOrganisations()
                .then((organisation) => {
                    this.activeOrganisation = organisation;
                });
        }

        $onInit(): void {
            this.user = this.selectedUser ?? this.modelsUtils.user();
            let uid =
                this.user && this.user.uid
                    ? this.user.uid
                    : this.selectedUserId;

            this.organisationUserDataProvider
                .getUser(uid)
                .then((user: User): void => {
                    this.user.setData(user);
                });
        }

        closeDialog(user: User): void {
            this.dialog.hide(user);
        }

        resetPassword(user): void {
            this.userDataProvider.resetPassword(user.uemail).then(
                () => {
                    this.toast.success(
                        "A reset password email has been sent to " + user.uemail
                    );
                },
                () => {
                    this.toast.error();
                }
            );
        }

        updateUser(user: User, event: any): void {
            this.dialog
                .show({
                    component: "vc-leader-user",
                    targetEvent: event,
                    clickOutsideToClose: false,
                    scope: this.$scope,
                    size: "large",
                    locals: {
                        organisation: this.activeOrganisation,
                        selectedUser: user,
                    },
                })
                .then((data: object) => {
                    _.merge(user, data);
                    this.onUserUpdated(user);
                });
        }

        removeUser(user: User, $event: any): void {
            this.dialog
                .delete({
                    targetEvent: $event,
                    fullscreen: true,
                    skipHide: true,
                    locals: {
                        title: "Delete User?",
                        bodyText:
                            "They will be permanently deleted from all associated campaigns",
                    },
                })
                .then(() => {
                    if (
                        this.activeOrganisation &&
                        this.activeOrganisation.oid
                    ) {
                        user.oid = this.activeOrganisation.oid;
                    }
                    this.organisationUserDataProvider
                        .deleteUser(user)
                        .then(() => {
                            this.onUserDeleted(user);
                            this.toast.success("User removed");
                            this.closeDialog(user);
                        });
                    this.userDataProvider.resetUsersCount();
                });
        }
        canUpdateUser(): boolean {
            const userPermission = this.user.permission.permissionid;
            const signedInUser = this.signedInUser;
            const signedInPermission =
                signedInUser.account_type == "ADMIN"
                    ? 8
                    : signedInUser.permission.permissionid;

            return (
                userPermission !== 8 &&
                ([8, 9].includes(signedInPermission) ||
                    (signedInPermission === 10 &&
                        ![9, 10].includes(userPermission)))
            );
        }
    },
};

angular
    .module("organisationUser")
    .component(
        ViewOrganisationUserComponent.selector,
        ViewOrganisationUserComponent
    );
